export interface SurveyTO {
  userQuestionnaireId: number;
  questions: SurveyQuestionTO[];
}

export interface SurveyQuestionTO {
  id: number;
  question: string;
  answers: string;
}

export const toSurveyTO = (data: any): SurveyTO => ({
  userQuestionnaireId: data.userQuestionnaireId,
  questions: data.questions.map((question: any) => ({
    id: question.id,
    question: question.question,
    answers: question.answers,
  })),
});
